import PropTypes from "prop-types"
import classNames from "classnames"
import { get, map } from "lodash"
import { Paper } from "@mui/material"
import CollapsePanel from "components/compare-collapse-panel"
import { colorWithOpacity } from "helpers/colors"
import FactorCategories from "components/factor-categories"
import { FACTOR_CATEGORIES_SHAPE } from "components/factor-categories/shapes"

import "./styles.scss"

export default function CompareTable({ data, items, columns, trackPanelTrigger, fixedItemNumber, className, factorCategories, firstCategoryOpened = false }) {
  const getValues = (getter) => map(columns, (column, index) => {
    const { isUnmodeled } = column || {}

    if (typeof getter !== "function" || !data[index] || isUnmodeled) { return null }
    return getter(data[index])
  })

  const getColumnColorStyle = (index) => {
    const { color, noData, isUnmodeled } = get(columns, index, {})
    const loading = !data[index] && !noData && !isUnmodeled

    return loading
      ? { background: `linear-gradient(90deg, ${colorWithOpacity(color, 0.1)}, ${colorWithOpacity(color, 0.3)})` }
      : { backgroundColor: colorWithOpacity(color, 0.1) }
  }

  return <Paper className={classNames(className, "components_compare-table")} square elevation={0}>
    {map(items, (item, index) => <CollapsePanel key={index} item={item} columns={columns} data={data} trackPanelTrigger={trackPanelTrigger} fixedItemNumber={fixedItemNumber} />)}
    <FactorCategories {...{
      getValues,
      getColumnColorStyle,
      categories: factorCategories,
      firstOpened: firstCategoryOpened,
    }}
    />

  </Paper>
}

CompareTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    noData: PropTypes.bool,
    isUmodeled: PropTypes.bool,
  })).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    color: PropTypes.string,
    defaultOpen: PropTypes.bool,
    fn: PropTypes.func,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      fn: PropTypes.func.isRequired,
    })),
  })).isRequired,
  data: PropTypes.array.isRequired,
  trackPanelTrigger: PropTypes.func.isRequired,
  fixedItemNumber: PropTypes.bool,
  className: PropTypes.string,
  factorCategories: FACTOR_CATEGORIES_SHAPE,
  firstCategoryOpened: PropTypes.bool,
}
